import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SettingsEntry } from '../../config/addin-core-config';
import { TranslatePipe } from '../../i18n/translate.pipe';

@Component({
  selector: 'cmi-settings-link',
  imports: [RouterLink, TranslatePipe],
  templateUrl: './settings-link.html'
})
export class SettingsLink {
  public readonly entry = input.required<SettingsEntry>();
}
